<template>
  <div id="app" :class="useFontFamilyClass">
    <div class="app-container-bg" v-if="!isMobile && !isTablet">
      <div
        class="bg"
        :class="{
          'container-hover': containerHoverStatus === 'hover',
          'container-leave': containerHoverStatus === 'leave',
        }"
      ></div>
    </div>
    <div class="app-container">
      <router-view />
    </div>
  </div>
</template>

<script>
import { setLang } from '@/utils/storage'
import { setItem } from '@/utils/storage-main.js'
import BaseMixin from '@/mixins/BaseMixin.js'
import { mapGetters } from 'vuex'
import { isGuest } from '@/utils/guest.js'
import { getBusinessChannel } from '@/utils/mutiple.js'
import { param2Obj } from '@/utils/utils'
import { setCurrentTitle, getBusinessType } from '@/constant'
import { isTablet } from '@/utils/index'

// 只有中文的语言的项目
const ONLY_CN_LANG_PROJECT = ['aia', 'aia-hr']

export default {
  name: 'App',
  data() {
    return {
      useFontFamilyClass: '',
      finnalFontFamily: '',
      isTablet,
    }
  },
  computed: {
    ...mapGetters(['containerHoverStatus']),
    trackParams() {
      return {
        source: this.$route.name === 'porsche911' ? 'porsche' : '',
        event_id: this.$route.name === 'porsche911' ? 'porsche' : '',
        scene_id: this.$route.name === 'porsche911' ? '911' : '',
      }
    },
  },
  created() {
    let { lang, name, dialog, mobileModel } = param2Obj(window.location.href)

    setCurrentTitle(name || 'gotin')

    this._setLoginLange(lang, name)

    if (dialog && dialog === '1') {
      this.$store.commit('setIsDialog', true)
    }
    if (mobileModel && mobileModel === '1') {
      this.$store.commit('setIsMobileModel', true)
    }
    getBusinessChannel(name || 'gotin')
    this.getFontFamily()
    this.getFontFamilyClass()
  },
  mounted() {
    // 监听父级应用event 传递过来的token级url
    window.addEventListener('message', function (event) {
      if (event.data.type === 'token') {
        setItem('Authorization', event.data.data.token)
        setItem('guestUrl', event.data.data.url)
      }
    })
    // 处理ui适配父级应用
    const { guest } = this.$route.query
    if (isGuest() && guest && guest !== 'yes') {
      const height = this.calcPageHeight(document)
      parent.document.getElementById('iframLogin').style.height = height + 'px'
    }
  },
  mixins: [BaseMixin],
  methods: {
    // 设置系统语言
    _setLoginLange(lang, name) {
      const tempLang = ONLY_CN_LANG_PROJECT.includes(name) ? 'cn' : lang

      if (!tempLang) return

      this.$i18n.locale = tempLang
      setLang(tempLang)
    },
    // 计算iframe高度
    calcPageHeight(doc) {
      var cHeight = Math.max(
        doc.body.clientHeight,
        doc.documentElement.clientHeight
      )
      var sHeight = Math.max(
        doc.body.scrollHeight,
        doc.documentElement.scrollHeight
      )
      var height = Math.max(cHeight, sHeight)
      return height
    },
    getFontFamilyClass() {
      if (getBusinessType().id === 'nissan') {
        this.useFontFamilyClass = 'HYQiHei'
      } else {
        this.useFontFamilyClass = getBusinessType()?.hasOwnFonts
          ? this.$i18n.locale === 'en'
            ? getBusinessType().fontNames
            : 'simhei_prosche'
          : this.$i18n.locale === 'en'
          ? 'en'
          : 'cn'
      }
    },
    getFontFamily() {
      this.finnalFontFamily = getBusinessType()?.hasOwnFonts
        ? getBusinessType().fontNames
        : this.$i18n.locale === 'en'
        ? 'Gotham'
        : 'PingFang SC'
    },
  },
  watch: {
    '$i18n.locale': {
      handler() {
        document.body.style.fontFamily = this.finnalFontFamily
      },
      immediate: true,
    },
    trackParams: {
      handler(params) {
        this.$gotinTrack.registerInfo(params)
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" vars="{ finnalFontFamily }">
#app {
  margin: 0;
  padding: 0;
  height: 100vh;
}

.cn {
  font-family: 'PingFang SC', sans-serif;
  .el-button {
    font-family: 'PingFang SC', sans-serif !important;
  }
}

.en {
  font-family: 'PingFang SC', Gotham, sans-serif;

  .el-button {
    font-family: 'PingFang SC', Gotham, sans-serif !important;
  }
}

.PorscheNextTT {
  font-family: 'PorscheNextTT', sans-serif;
  .el-button {
    font-family: 'PorscheNextTT', sans-serif !important;
  }
  .el-input {
    font-family: 'PorscheNextTT', sans-serif !important;
  }
}

.simhei_prosche {
  font-family: 'Simhei_Porsche', sans-serif;
  .el-button {
    font-family: 'Simhei_Porsche', sans-serif !important;
  }
  .el-input {
    font-family: 'PorscheNextTT', sans-serif !important;
  }
}
.HYQiHei {
  font-family: 'HYQiHei' !important;
  .el-button {
    font-family: 'HYQiHei' !important;
  }
  .el-input {
    font-family: 'HYQiHei' !important;
  }
}

input,
textarea,
pre {
  font-family: var(--finnalFontFamily);
}
</style>
<style lang="scss" scoped>
.app-container {
  height: 100vh;
}
.app-container,
.app-container-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.app-container-bg {
  position: fixed;
  overflow: hidden;
}
.app-container-bg {
  .bg {
    height: 100vh;
    overflow: hidden;
    background: center center url('assets/images/login/login-bg.png') no-repeat;
    background-size: cover;
    transition: 0.5s ease-in-out;
    animation-duration: 0.6s;
    animation-fill-mode: forwards;
    &.container-hover {
      background: center center url('assets/images/login/login-bg-light.png')
        no-repeat;
      background-size: cover;
      animation-name: hover;
    }
    &.container-leave {
      animation-name: leave;
    }
  }
}

@keyframes hover {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.2);
  }
}
@keyframes leave {
  from {
    transform: scale(1.2);
  }
  to {
    transform: scale(1);
  }
}
</style>
